/**
 * Auswahl des Bereichs neben einer Schnellerfassung - nur sichtbar, wenn zwei
 * oder mehr Bereiche gefiltert sind. Siehe `useCaptureArea`.
 */
import { useAreaMap } from '@/modules/areas/useAreas';
import { cn } from '@/lib/utils/cn';
import type { ID } from '@/domain/types';

export function CaptureAreaSelect({
  value, choices, onChange, className,
}: {
  value: ID | null;
  choices: ID[];
  onChange: (id: ID) => void;
  className?: string;
}) {
  const areas = useAreaMap();

  if (choices.length < 2 || value === null) return null;

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Bereich für den neuen Eintrag"
      title="Bereich für den neuen Eintrag"
      className={cn(
        'h-10 max-w-40 shrink-0 rounded-lg border border-line bg-surface px-2 text-sm text-ink-muted',
        'focus:border-accent focus:outline-none',
        className,
      )}
    >
      {choices.map((id) => (
        <option key={id} value={id}>{areas.get(id)?.name ?? '…'}</option>
      ))}
    </select>
  );
}
